// b76dff1dffdd73059d690f98d75e9d8dca1de0b6|name=UserMemory|schemaHash=a27e38efca7113a79e8dab53622ccade1113cfaf|kind=parser-js

import { setDefinedValue } from '@myre/common-primitives';

export function parseUserMemoryFromJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'preferences', _data.preferences);
  setDefinedValue(result, 'instructions', _data.instructions);

  return result;
}

export function parseUserMemoryToJSON(
  _data,
) {
  if (!_data) {
    return _data;
  }

  const result = {};

  setDefinedValue(result, 'preferences', _data.preferences);
  setDefinedValue(result, 'instructions', _data.instructions);

  return result;
}
